import { User } from '@/interfaces/userInfo';
import { Site } from '@/interfaces/multiTenancy';
import { Role } from '@/interfaces/types';

function checkClientSitePermission(user: User): boolean {
	return !(!user.clients.length || !user.sites.length);
}

function checkUserRole(user: User, roles: Role[], site: Site): Role | null {
	for (const roleId in user.roles) {
		const currentRole = roles.find((role) => role.id === Number(roleId));

		if (!currentRole) {
			break;
		}

		if (user.roles[roleId] === null) {
			return currentRole;
		}

		if (user.roles[roleId].some((client) => client === site.fk_client)) {
			if (user.sites.some((_site) => Number(_site) === site.id)) {
				return currentRole;
			}
		}
	}

	return null;
}

function hasPermission(role: Role, privilege: string[] = []): boolean {
	if (!role) {
		return false;
	}

	if (role.privileges.some((privilege) => privilege.includes('admin'))) {
		return true;
	}

	if (privilege.length === 0) {
		return false;
	}

	const actions = privilege[1] == 'write' ? ['write'] : ['write', 'read'];

	return role.privileges.some((p) => p[0] === privilege[0] && actions.includes(p[1]));
}

const permissions = {
	checkClientSitePermission,
	checkUserRole,
	hasPermission,
};

export default permissions;
